var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  // if (itemCollections.toLowerCase().indexOf('Holiday'.toLowerCase()) > -1) {
  //   specialProduct1 = true;
  // } 

  // if (itemCollections.toLowerCase().indexOf('november 22'.toLowerCase()) > -1) {
  //   specialProduct2 = true;
  // } 

  if (itemTitle.toLowerCase().indexOf('Pumpkin Pie'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }
}

for (let i = 0; i < crVariants.length; i++ ){
  var variantTitle = crVariants[i].variant_title;
  if (!variantTitle) continue;
  console.log({variantTitle})  
  

  if ( (variantTitle.toLowerCase().indexOf('10 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('11 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('12 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('13 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('14 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('15 inch'.toLowerCase()) > -1)
  || (variantTitle.toLowerCase().indexOf('16 inch'.toLowerCase()) > -1)
     ) {
    specialProduct2 = true;
  }
}

// var specialProduct = false;
// var products = CRoverRidingRules[0]?.products;
// for (var i = 0; i < products.length; i++) {
//   var ruleVariants = products[i].variants;

//   for (var j = 0; j < crVariants.length; j++){
//     var cartItemVariantId = crVariants[j].variant_id 
//     var found = ruleVariants.find((element) => {
//       return element.plainVariantId == cartItemVariantId
//     })
// 	if (found) specialProduct = true;
//   }
// }

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct2 === true) {  
    picker.set('min', 7);   
  }	
 if (specialProduct1 === true) {
    picker.set('disable', [true, 
                         //  { from: [2020, 8, 10], to: [2023, 11, 21] }, 
                          
                           { from: [2024, 11, 25], to: [2025, 11, 1] }
                          ]);
    picker.set('max', 100); 
   /*picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2023, 8, 26] }, 
                           [2023, 9, 9],
                           { from: [2023, 11, 1], to: [2025, 11, 1] }
                          ]);*/
  }  else {
    picker.set('disable', blackoutdatesCollection);  
  }
}